export const HIGHLIGHT_COLOR = '#fecf34';

export const INPUT_ICON_DEFAULT_SIZE = {
  width: '0.85em',
  height: '0.85em',
};

export const ZOOM_STYLES = {
  root: {
    color: '#0768fd',
    display: 'inline-block',
    width: '42px',
    paddingLeft: '10px',
    paddingRight: '10px',
    cursor: 'pointer',
    verticalAlign: 'bottom',
    flex: '0 1 auto',
  },
  zoomEditMode: {
    paddingTop: '10px',
    margin: 0,
  },
  inTable: {
    marginTop: 31,
  },
  inSubGridOrMobile: {
    marginTop: 51,
  },
  rightAlignIcons: {
    position: 'absolute',
    left: 43,
  },
  searchIcon: INPUT_ICON_DEFAULT_SIZE,
};

export const MODEL_PICKER_MODAL_STYLES = {
  height: '80%',
  '@media (max-height: 850px)': {
    height: '100%',
  },
  '@media (max-width: 800px)': {
    width: '90%',
  },
  '@media (max-width: 1800px)': {
    minWidth: '40%',
  },
  '@media (min-width: 1801px)': {
    minWidth: '35%',
  },
  '& [class*="MuiDialogContent"]': {
    paddingBottom: 10,
  },
};

export const ENTITY_MODEL_PICKER_STYLES = {
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: ({ height }) => height || '100%',
    width: ({ width }) => width || '100%',
  },
  treeContainer: {
    border: '1px solid #ccc',
    overflow: 'auto',
    overflowX: 'hidden',
    backgroundColor: 'white',
    height: '100%',
  },
  searchInput: {
    marginTop: 0,
    '& div': {
      marginTop: 0,
    },
  },
  clearIcon: INPUT_ICON_DEFAULT_SIZE,
};
